class MediaShowcase extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Event listeners voor responsive gedrag
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
		
		// Smooth scroll functionaliteit
		this.initSmoothScroll();
		
		// Accessibility verbeteringen
		this.initAccessibility();
	}

	handleResize() {
		// Responsive gedrag wordt nu gedaan via CSS
		// Dit kan uitgebreid worden voor meer complexe responsive gedrag
	}

	initSmoothScroll() {
		const container = this.querySelector('.media-showcase__brand-container');
		if (container) {
			// Voeg smooth scroll toe voor touch devices
			container.addEventListener('touchstart', () => {
				container.style.scrollBehavior = 'smooth';
			});
		}
	}

	initAccessibility() {
		// Voeg ARIA labels toe voor betere toegankelijkheid
		const brandItems = this.querySelectorAll('.media-showcase__brand-item');
		brandItems.forEach((item, index) => {
			item.setAttribute('aria-label', `Brand logo ${index + 1}`);
		});
	}
}

// Registreer de custom element
customElements.define('media-showcase', MediaShowcase);
